import { UpdateProOrganizerRequestDto } from "@smatchy/sdk";
import { ProOrganizerRequestEntity } from "../../domains";

export class UpdateRequest {
    static readonly type = '[ProOrganizerRequest] UpdateRequest';
    constructor(public id: string, public payload: UpdateProOrganizerRequestDto) {}
}

export class UpdateRequestSuccess {
    static readonly type = '[ProOrganizerRequest] UpdateRequestSuccess';
    constructor(public response: ProOrganizerRequestEntity) {}
}

export class UpdateRequestFail {
    static readonly type = '[ProOrganizerRequest] UpdateRequestFail';
    constructor(public error: unknown) {}
}